// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"d9372ed619c853e55a3b","112":"7bb77a947fd909c84a40","113":"f30f2294c22631c4d43f","160":"cdcba2dc1e8f56ca040b"}[chunkId] + ".chunk.js";
};